'use client';

import { Check, Copy } from '@phosphor-icons/react';
import { useState } from 'react';

import { cn } from '@skrym/shared/utils/cn';

interface ColorProps {
  hex: string;
  label?: string;
}

function ColorTag(props: ColorProps) {
  const { hex, label } = props;
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(hex);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // reset after 1.5 seconds
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <button
      type="button"
      onClick={copyToClipboard}
      onKeyDown={copyToClipboard}
      className={cn(
        'group',
        'inline-flex items-center gap-1 rounded-lg px-1.5 cursor-pointer',
        'hover:dark:bg-gray-200/10 hover:bg-neutral-800/10',
      )}
      title={copied ? 'Copied!' : 'Click to copy hex value'}
    >
      <span style={{ backgroundColor: hex }} className="h-3 w-3 rounded-[0.25rem]" />
      <span className="font-semibold whitespace-nowrap">{label ? label : hex.toUpperCase()}</span>
      {copied ? (
        <Check weight="bold" className="fill-transparent group-hover:fill-gray-500" />
      ) : (
        <Copy weight="bold" className="fill-transparent group-hover:fill-gray-500" />
      )}
    </button>
  );
}

export default ColorTag;
